import { lazy, Suspense } from 'react';

const OpenApiWorkspace = lazy(() => import('./APITool/OpenApiWorkspace'));

// Preserve the existing authenticated route and keep parser assets route-local.
export default function APITool() {
  return <Suspense fallback={<p role="status">Loading OpenAPI workspace…</p>}><OpenApiWorkspace /></Suspense>;
}
